/**
 * Caso o parâmetro seja _undefined_ ou lista vazia, retorna undefined.
 *
 * @template T
 * @param {T[]} [list]
 * @return {*}  {T[]}
 */
export const optional = <T>(list?: T[]): T[] | undefined => (list?.length ? list : undefined);
